// export default function BottomCta({ title, subtitle }) {
//   return (
//     <section className="w-full py-16 sm:py-20 lg:py-24 xl:py-28 2xl:py-32 px-4 sm:px-6 bg-black">
      
//       {/* FULL WIDTH CONTROL (VERY IMPORTANT FOR ULTRA WIDE) */}
//       <div className="w-full mx-auto 
//         max-w-[1280px] 
//         lg:max-w-[1440px] 
//         xl:max-w-[1680px] 
//         2xl:max-w-[2000px] 
//         3xl:max-w-[2400px]">

//         {/* CONTENT BLOCK */}
//         <div className="text-center flex flex-col items-center">

//           <h2 
//             className="w-full max-w-4xl text-white font-bold leading-tight mb-5"
//             style={{ 
//               fontSize: "clamp(28px, 5vw, 48px)",
//               fontWeight: "700",
//               lineHeight: "1.3"
//             }}
//           >
//             {title}
//           </h2>

//           <p 
//             className="w-full max-w-2xl text-white/80 mb-10"
//             style={{ 
//               fontSize: "clamp(14px, 1.2vw, 16px)",
//               lineHeight: "1.6"
//             }}
//           >
//             {subtitle}
//           </p>

//           {/* BUTTONS */}
//           <div className="flex flex-col sm:flex-row gap-4 justify-center w-full">
            
//             <a
//               href="/contact"
//               className="
//                 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold
//                 bg-[#B8893A] text-white
//                 text-sm sm:text-base lg:text-lg xl:text-xl
//                 hover:bg-[#A67B34] transition
//               "
//             >
//               Get Free Consultation
//             </a>

//             <a
//               href="/calculator"
//               className="
//                 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold
//                 border border-white/20 text-white
//                 text-sm sm:text-base lg:text-lg xl:text-xl
//                 hover:bg-white/10 transition
//               "
//             >
//               Calculate Your Cost
//             </a>

//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }




import Link from "next/link";

export default function BottomCta({ title, subtitle, image }) {
  return (
    <section className="relative w-full py-12 sm:py-16 lg:py-20 xl:py-24 px-4 mb-12 lg:mb-16 overflow-hidden shadow-2xl">
      
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={image || "/bcta.webp"}
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/55" />
      </div>

      {/* Content */}
      <div className="relative main-container text-center text-white">

        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 text-white
                     px-4 py-1.5 rounded-full text-[11px] sm:text-sm
                     font-semibold mb-5 sm:mb-6"
          style={{
            background: "linear-gradient(135deg,#B8893A 0%,#D4A754 100%)",
          }}
        >
          Limited Slots Available
        </div>

        {/* Heading */}
        <h2 
          className="font-bold mb-6 leading-tight uppercase max-w-4xl mx-auto"
          style={{ 
            fontSize: "clamp(28px, 5vw, 48px)",
            fontWeight: "700",
            lineHeight: "1.3"
          }}
        >
          {title || "BUILD YOUR EMPIRE NOW"}
        </h2>

        {/* Description */}
        <p 
          className="text-gray-300 mb-10 max-w-3xl mx-auto"
          style={{ 
            fontSize: "clamp(14px, 1.2vw, 16px)",
            lineHeight: "1.6"
          }}
        >
          {subtitle || "AWS Businessmen simplifies your journey to success in the UAE and beyond. From company formation and worldwide visa services to immigration, accounting, and tax compliance, we provide complete, reliable support so you can focus on growing your business."}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
          
      

          {/* Get Free Consultation Button */}
          <Link
            href="https://wa.me/971586009983"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-white font-bold
                       px-8 py-4 rounded-full
                       transition-all duration-300
                       hover:scale-[1.05] active:scale-[0.98]
                       shadow-lg hover:shadow-2xl"
            style={{
              background: "linear-gradient(135deg,#B8893A 0%,#D4A754 100%)",
            }}
          >
            {/* WhatsApp Icon */}
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0"
            >
              <path 
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" 
                fill="currentColor"
              />
            </svg>
            
            
            <span>Get Free Consultation</span>

            
          </Link>
            {/* WhatsApp Call Button */}
          <Link
            href="https://wa.me/971586009983?text=I%20would%20like%20to%20schedule%20a%20call"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center
                       w-14 h-14 rounded-full
                       bg-white/10 backdrop-blur-sm
                       border-2 border-white/20
                       transition-all duration-300
                       hover:scale-110 hover:bg-white/20
                       active:scale-95
                       shadow-lg hover:shadow-2xl
                       group"
            aria-label="WhatsApp Call"
          >
            {/* Phone Icon */}
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="text-white group-hover:text-[#D4A754] transition-colors duration-300"
            >
              <path 
                d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}